import { API, Storage } from 'aws-amplify';
import { get, set } from 'idb-keyval';
import axios from 'axios';
import { eventChannel, END } from 'redux-saga';
import awsexports from '../../aws-exports';
import { MediaType, MEDIA_INDEXED_KEY } from './types';

API.configure(awsexports);
Storage.configure(awsexports);

export const getSignedURL = async (payload: MediaType): Promise<MediaType | null> => {
    let localUri = '';
    let localMedia: MediaType;
    if (payload.key)
        return (
            Storage.get(payload.key, { level: 'public', expires: 3600 })
                // eslint-disable-next-line  @typescript-eslint/no-explicit-any
                .then((uri: any) => {
                    localUri = uri;
                    return get(MEDIA_INDEXED_KEY);
                })
                .then((indexedMedias: MediaType[] = []) => {
                    localMedia = {
                        key: payload.key,
                        ...(indexedMedias.find((m: MediaType) => m.key === payload.key) || {}),
                        uri: localUri,
                    };
                    const filtered =
                        indexedMedias.filter((m: MediaType) => m.key !== payload?.key) || [];
                    return set(MEDIA_INDEXED_KEY, [...filtered, localMedia]);
                })
                .then(() => {
                    return localMedia;
                })
                .catch((e) => {
                    // eslint-disable-next-line no-console
                    console.info(e);
                    return null;
                })
        );
    return null;
};

export const getMedia = async (media: MediaType) => {
    const signedMedia = await getSignedURL(media);
    return eventChannel((emitter) => {
        let counter = 0;
        const onProgress = (progressEvent: ProgressEvent) => {
            if (progressEvent.lengthComputable) {
                const percentCompleted = Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total,
                );
                if (percentCompleted > counter) {
                    counter += 5;
                    emitter({
                        ...signedMedia,
                        progress: percentCompleted || 1,
                        isDownloading: true,
                    });
                }
            }
        };

        const onFailure = (e: ProgressEvent) => {
            emitter({ error: e });
            emitter(END);
        };

        let blob: Blob;
        axios({
            url: signedMedia?.uri,
            method: 'GET',
            responseType: 'blob', // important
            onDownloadProgress: onProgress,
        })
            .then((response) => {
                blob = response.data;
                return get(MEDIA_INDEXED_KEY);
            })
            .then((medias) => {
                const filtered = medias?.filter((m: MediaType) => m.key !== signedMedia?.key) || [];
                return set(MEDIA_INDEXED_KEY, [
                    ...filtered,
                    {
                        ...signedMedia,
                        blob,
                        progress: 100,
                        isDownloading: false,
                    },
                ]);
            })
            .then(() => {
                emitter({ ...signedMedia, progress: 100, isDownloading: false });
                return emitter(END);
            })
            .catch(onFailure);

        return async () => {
            // eslint-disable-next-line  no-console
            console.log('Finish...');
        };
    });
};

export const listMedias = async (): Promise<MediaType[]> => {
    const medias = (await Storage.list('medias/', { level: 'public' })) || [];
    return (
        medias
            ?.filter((m: { size: number }) => m.size > 0)
            .map(({ key }: { key: string }) => ({ key })) || []
    );
};
